<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="form.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
                @blur="$emit('on-name-change', form.name)"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label>Enable this form only for logged users</label>
            <b-form-checkbox v-model="form.loggedInOnly" switch />
        </div>
        <div class="form-group col-12">
            <label>Hide title</label>
            <b-form-checkbox v-model="form.hideTitle" switch />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            form: {}
        };
    },

    watch: {
        form() {
            this.$emit('input', this.form);
        }
    },

    mounted() {
        this.form = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                this.validation.form[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.form,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
